import React from 'react';
import { styles } from '4all-ui/styles';
import {
  STATUS_DELIVERED,
  PAYMENT_MONEY,
  PAYMENT_DEBIT,
  PAYMENT_TICKET,
  STATUS_NOT_PAID,
} from './constants';
import CardIcon from '../components/Icons/Card';
import MoneyIcon from '../components/Icons/Money';

export default function parsePayment(method = {}, status, paymentStatus = 0) {
  const isPresentialPaymentMethod = [PAYMENT_DEBIT, PAYMENT_MONEY, PAYMENT_TICKET].some(
    type => type === method.id
  );
  let payment = {
    label: '',
    name: '',
    color: '#CCC',
    icon: null,
  };

  const color = method.id === PAYMENT_MONEY ? styles.colors.MAIN_COLOR : styles.colors.INFO_COLOR;

  if (!Object.keys(method).length && paymentStatus !== STATUS_NOT_PAID) {
    payment = {
      ...payment,
      label: 'Pago Online',
      name: 'Pago',
      color,
      ...method,
      icon: <CardIcon color={color} />,
    };
  } else if (status === STATUS_DELIVERED) {
    payment = {
      label: isPresentialPaymentMethod ? 'Pago Presencial' : 'Pago Online',
      name: method.name,
      color,
      icon: method.id === PAYMENT_MONEY ? <MoneyIcon color={color} /> : <CardIcon color={color} />,
      ...method,
    };
  } else {
    payment = {
      label: 'Não Pago',
      name: method.name,
      color: '#d23f31',
      icon:
        method.id === PAYMENT_MONEY ? <MoneyIcon color="#d23f31" /> : <CardIcon color="#d23f31" />,
      ...method,
    };
  }
  return payment;
}



// WEBPACK FOOTER //
// ./src/helpers/payment.js